import React, { useState, useEffect, useRef } from "react";

const RenderData = ({ options, onSelect, setname, value, disab, inputRef }) => {
  const [filteredOptions, setFilteredOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const dropdownRef = useRef(null);

  const fetchData = async () => {
    if (value) {
      const filtered = await options.filter((option) => option.value === value);
      // console.log(filtered[0].label);
      if (filtered[0].label1) {
        setSearchTerm(filtered[0].label1);
        setSelectedOption(filtered[0].label1);
      }
    }
  };
  useEffect(() => {
    value && fetchData();
  }, [value]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        // Clicked outside the dropdown, close it
        setIsFocused(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      // Clean up the event listener when the component is unmounted
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    // Filter options based on the search term
    const filtered = options.filter((option) =>
      option.label.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [searchTerm, options]);

  const handleSelect = (option) => {
    setSearchTerm(option.label1);
    setSelectedOption(option.label1);
    onSelect(option);
    setIsFocused(false);
    inputRef.current.blur();
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  return (
    <div ref={dropdownRef} className="searchable-dropdown">
      <input
        ref={inputRef}
        type="text"
        className="input-style"
        onFocus={handleFocus}
        value={selectedOption || "Choose customer..."}
        disabled={disab}
        readOnly
      />
      {isFocused && (
        <ul className="options-list">
          <li>
            <input
              type="text"
              placeholder="Search..."
              // value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              disabled={disab}
              style={{ width: "100%" }}
            />
          </li>
          {filteredOptions.map((option) => (
            <li
              key={option.value}
              onMouseDown={(e) => e.preventDefault()} // Prevents blur on option click
              onClick={() => handleSelect(option)}
              className="option"
            >
              {option.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const SearchableDropdown = (props) => {
  const { label, labelClass, Option, setname, key_name, handleChange, disab } =
    props;
  const inputRef = useRef(null);
  const handleSelects = (option) => {
    // console.log("Selected:", option);
    const event = { target: { name: key_name, value: option.value } };
    handleChange(event);
  };
  return (
    <div>
      <label className={labelClass ? labelClass : "label"}>{label}</label>
      <RenderData
        options={Option}
        value={props[key_name]}
        setname={setname}
        disab={disab}
        onSelect={handleSelects}
        inputRef={inputRef}
      />
    </div>
  );
};

export default SearchableDropdown;
